import {Component, Input} from '@angular/core';
import {ModalController, NavController, NavParams, PopoverController} from 'ionic-angular';
import {ProfilePage} from "../profile/profile";
import {ProfileDeleteAccountModalPage} from "../profile-delete-account-modal/profile-delete-account-modal";
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

/**
 * Generated class for the ProfileAccountDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-profile-account-details',
    templateUrl: 'profile-account-details.html',
})
export class ProfileAccountDetailsPage {

    errors: {};
    loading: boolean;

    account: any;
    name: string;
    email: string;
    phone: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    private http: HttpClient,
    private apiErrorHandler: ApiErrorHandlerProvider
  ) {
        this.account = navParams.get('account');
    }

    openModal() {
        let deleteAccountModal = this.popoverCtrl.create(ProfileDeleteAccountModalPage,
            {
                // @ts-ignore
                accountId: this.account.id
            },
            {
                cssClass: 'delete-account-modal',
                enableBackdropDismiss: false
            });

        deleteAccountModal.present();
    }

    update() {
        this.loading = true;

        this.http.post('/user', {
            id: this.account.id,
            name: this.name,
            email: this.email,
            phone: this.phone,
        }).subscribe(
            data => {
                this.account.name = this.name;
                this.account.email = this.email;
                this.account.phone = this.phone;

                this.errors = {};
                this.loading = false;

                // Pop the user back to the previous profile page
                this.navCtrl.pop();

            }, error => {
                this.loading = false;
                this.errors = this.apiErrorHandler.handleError(error);
            })
    }

}



// WEBPACK FOOTER //
// ./src/pages/profile-account-details/profile-account-details.ts